module.exports = "/_next/static/images/sy-9300705001ec606312cbaeab929419a6.svg";